module.exports = __webpack_public_path__ + "img/山东.757aa208.png";